import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Popover, Spinner } from "react-bootstrap"
import { connect } from "react-redux"
import { AppState } from "src/store"
import Select from "react-select"
import mutator from "src/utilities/mutator"
import ReferenceTypes from "../../Types/ReferenceTypes"
import addEmployeeKeys from "./AddEmployeeKeys"
import AddEmployeeTypes from "./AddEmployeeTypes"
import axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import snackBar from "src/utilities/snackBar/SnackBar"
import EmployeeDataTypes from "../../Types/EmployeeTypes"
import hashTable from "src/utilities/hash/hashTable"
import MsalAuth from "src/utilities/msalAuth"
import moment from "moment"
import reggie from "src/utilities/Reggie"
import { createPayRateHistory } from "src/components/vault77/payRateHistory/api/payRateHistory.api"
import { getVault77ErrorMessage } from "src/components/vault77/core/apiError"
import "./AddEmployee.css"

interface Props {
    manageParentState: Function
    insertEmployee: Function
    userReference: ReferenceTypes
    userId: string | number
    employees: Array<EmployeeDataTypes>
}

interface State {
    employee: AddEmployeeTypes | {}
    loading: boolean
    eventType: string
}

class AddEmployee extends Component<Props, State> {

    autoCapsList = ["FirstName", "MiddleName", "LastName"]
    employeeNumbers = []
    storageSize = 0
    hashTable: any

    state = {
        employee: { EmployeeNumber: null, HireDate: null, PayRate: null },
        loading: false,
        eventType: ""
    }

    componentDidMount() {
        let employee = {}
        this.storageSize = Math.floor(this.props.employees.length / 2)
        this.hashTable = new hashTable(this.storageSize)
        const keys = addEmployeeKeys.sort()
        for (let i = 0; i < keys.length; i++) {
            //@ts-ignore
            employee[keys[i].key] = null
        }
        //build a hash table for faster employee number lookup times
        for (let i = 0; i < this.props.employees.length; i++) {
            const employee = this.props.employees[i]
            if (employee.EmployeeNumber) {
                this.hashTable.addItem([employee.EmployeeNumber, this.hashTable.hash(employee.EmployeeNumber, this.storageSize), employee])
            }
        }

        this.manageState([{ key: "employee", value: employee }])
    }

    componentWillUnmount() {
        this.hashTable.purgeTable()
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        if(this.state.eventType === "EmployeeNumber" || this.state.eventType === "UserName"){
            input = reggie.joinString(input)
         }
        let temp = this.state.employee
        //@ts-ignore
        temp[this.state.eventType] = this.autoCaps(input === "" ? null : input)
        // temp[this.state.eventType] = this.autoCaps(input === "" ? null : this.state.eventType === "PayRate" ? parseFloat(input) : input)
        // temp[this.state.eventType] = this.autoCaps(input === "" ? null : this.state.eventType === "PayRate" ? (!isNaN(parseFloat(input)) ? parseFloat(input) : null) : input)
        this.setState({ employee: temp })
    }

    autoCaps = (input: string | null) => {
        if (input && (this.autoCapsList.includes(this.state.eventType))) {
            return input.charAt(0).toUpperCase() + input.slice(1)
        }
        return input
    }

    formStatus = () => {
        const keys = addEmployeeKeys
        const employee = this.state.employee || {}
        let missing = []
        let aliases = []
        for (let i = 0; i < keys.length; i++) {
            //@ts-ignore
            const validInput = typeof employee[keys[i].key] === keys[i].type
            const required = keys[i].required
            if (!validInput && required) {
                missing.push(keys[i].key)
                aliases.push(keys[i].alias)
            }
        }
        //@ts-ignore
        if (typeof (parseInt(employee.PayRate)) !== "number" || employee.PayRate < .01) {
            missing.push("PayRate")
            aliases.push("Pay Rate < 0.01")
        }
        return { canSubmit: missing.length === 0, missing: missing, aliases: aliases }
    }

    getDescriptor = (id: number, key: string, fallback: string) => {
        //@ts-ignore
        let ref = this.props.userReference[key] || []
        for (let i = 0; i < ref.length; i++) {
            if (id === ref[i].id) {
                return ref[i].text
            }
        }
        return fallback
    }

    formatDate = (str: string | null) => {
        const date = moment(str).format("MM/DD/YYYY")
        return date
    }

    addEmployee = () => {
        this.manageState([{ key: "loading", value: true }])
        let rb = JSON.parse(JSON.stringify(this.state.employee))
        delete rb.PayRate
        rb.HireDate = this.formatDate(rb.HireDate)
        axios.post(process.env.REACT_APP_API_URL + "/api/user/AddUser", rb, AxiosConfig.configValue("min"))
            .then((res) => {
                const response = res.data
                if (Array.isArray(response)) {
                    this.createPayRate(response[0])
                } else {
                    const msg = response.ValidationMessage ? response.ValidationMessage : ""
                    snackBar({ text: `Error Updating Employee Info: ${msg}`, type: "error", timeout: 8000 })
                    this.manageState([{ key: "loading", value: false }])
                }
            }).catch(err => {
                console.log(err)
                this.manageState([{ key: "loading", value: false }])
                snackBar({ type: "error", text: "Failed to add a new employee", timeout: 8000 })
            })
    }

    // Create the new employee's initial Vault77 PayRateHistory record (replaces the legacy Area51
    // secure-session + ExternalAddPayrate flow). This goes through the normal authenticated API; the
    // Vault77 data layer handles Always-Encrypted writes + auto-supersede. EffectiveDate is the hire
    // date and PayType carries the selected type so the rate row is self-describing.
    createPayRate = async (employee: AddEmployeeTypes) => {
        const draft = this.state.employee as any
        try {
            await createPayRateHistory({
                EmployeeId: employee.UserId,
                PayRate: Number(draft.PayRate),
                //@ts-ignore - OriginalHireDate is returned by AddUser but isn't on AddEmployeeTypes.
                EffectiveDate: moment(employee.OriginalHireDate || draft.HireDate).format("YYYY-MM-DD"),
                EndDate: null,
                PayType: draft.PayType || null,
                SystemComment: "User Quick Add",
            })
            this.manageState([{ key: "loading", value: false }])
            this.props.insertEmployee(employee)
            this.props.manageParentState([{ key: "addEmployee" }])
            snackBar({ type: "success", text: "Employee added", timeout: 3000 })
        } catch (err) {
            // The employee was already created by AddUser; only the pay rate failed. Re-submitting would
            // duplicate the employee, so close out and insert them anyway — the missing rate then shows
            // up on the health dashboard (MISSING_PAY_RATE) and can be added from the User Admin tab.
            this.manageState([{ key: "loading", value: false }])
            this.props.insertEmployee(employee)
            this.props.manageParentState([{ key: "addEmployee" }])
            snackBar({
                type: "error",
                text: getVault77ErrorMessage(err, "Employee added, but the pay rate could not be saved. Add it from the User Admin tab."),
                timeout: 8000,
            })
        }
    }

    render() {

        const props = this.props
        const state = this.state
        const employee = state.employee
        const formStatus = this.formStatus()
        const employeeExists = (employee && employee.EmployeeNumber)
            ? this.hashTable.lookupItem(employee.EmployeeNumber, this.hashTable.hash(employee.EmployeeNumber, this.storageSize))
            : false
        const canSubmit = formStatus.canSubmit && !employeeExists

        // //console.log("??? formStatus", formStatus)
        // //console.log("??? employee", employee)

        const missingFieldsdpopover = (
            <Popover id="add-employee-missing-fields-popover">
                {!formStatus.canSubmit && <div className="AddEmployeeMissingFieldsPopoverHeader">
                    <p>The following fields are missing</p>
                </div>}
                {formStatus.aliases.map((item: string, index: number) =>
                    <div className="AddEmployeeMissingFieldsPopoverItem" key={`add-employee-missing-fields-popover-item-${index}`}>
                        <p>{`${index + 1}. ${item}`}</p>
                    </div>)}
                {employeeExists && <div className="AddEmployeeMissingFieldsPopoverItem">
                    <div className="AddEmployeeMissingFieldsPopoverHeader AddEmployeeMissingFieldsPopoverHeaderLower">
                        <p>The following fields need revision</p>
                    </div>
                    <div className="AddEmployeeMissingFieldsPopoverItem">
                        <p>1. Employee number already belongs to: <span>{employeeExists[2].DisplayName}</span></p>
                    </div>
                </div>}
            </Popover>
        )

        const addEmployeePopover = (text: string, spanText?: string) => (
            <Popover id="add-employee-popover">
                <div className="AddEmployeePopover">
                    <p>{text}</p>
                    {spanText && <span>{spanText}</span>}
                </div>
            </Popover>
        )

        return (
            <div className="AddEmployee">
                <Modal
                    id="add-employee-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="AddEmployeeFormHeader">
                            <span className="material-icons">person</span>
                            <p>Add a new employee</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {employee && <div className="AddEmployeeForm">
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>First Name</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("FirstName") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "FirstName" }])}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={employee.FirstName || ""}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Middle Initial</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("MiddleName") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "MiddleName" }])}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={employee.MiddleName || ""}
                                    maxLength={1}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Last Name</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("LastName") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "LastName" }])}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={employee.LastName || ""}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Username</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("UserName") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "UserName" }])}
                                    onChange={this.handleChange}
                                    //@ts-ignore
                                    value={employee.UserName || ""}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Employee Number</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("EmployeeNumber") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                        {/*@ts-ignore*/}
                                        {employeeExists && <OverlayTrigger delay={{ show: 0, hide: 400 }} placement="top" overlay={addEmployeePopover("Employee number already belongs to :", employeeExists[2].DisplayName)} >
                                            <span className="material-icons AddEmployeeFormItemStatusMarkerEmployeeNumberTaken">priority_high</span>
                                        </OverlayTrigger>}
                                    </div>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "EmployeeNumber" }])}
                                    onChange={this.handleChange}
                                    value={employee.EmployeeNumber || ""}
                                    type="number"
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Hire Date</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("HireDate") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "HireDate" }])}
                                    onChange={this.handleChange}
                                    value={employee.HireDate || ""}
                                    type="date"
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Home Profit Center</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("HomeProfitCenterId") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <Select
                                    //@ts-ignore
                                    value={{ label: this.getDescriptor(employee.HomeProfitCenterId, "profitCenters", "") }}
                                    options={props.userReference.profitCenters.map((s) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: { value: string, label: string }) => {
                                        let temp = employee
                                        //@ts-ignore
                                        temp.HomeProfitCenterId = item.value
                                        this.manageState([{ key: "employee", value: temp }])
                                    }}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Supervisor</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("SupervisorId") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <Select
                                    //@ts-ignore
                                    value={{ label: this.getDescriptor(employee.SupervisorId, "supervisors", "") }}
                                    options={props.userReference.supervisors.map((s) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: { value: string, label: string }) => {
                                        let temp = employee
                                        //@ts-ignore
                                        temp.SupervisorId = item.value
                                        this.manageState([{ key: "employee", value: temp }])
                                    }}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Pay Type</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("PayType") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <Select
                                    //@ts-ignore
                                    value={{ label: employee.PayType || "" }}
                                    options={props.userReference.payTypes.map((s) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: { value: string, label: string }) => {
                                        let temp = employee
                                        //@ts-ignore
                                        temp.PayType = item.label
                                        this.manageState([{ key: "employee", value: temp }])
                                    }}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>PTO Plan</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("PtoPlanId") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <Select
                                    //@ts-ignore
                                    value={{ label: this.getDescriptor(employee.PtoPlanId, "ptoPlans", "") }}
                                    options={props.userReference.ptoPlans.map((s) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: { value: string, label: string }) => {
                                        let temp = employee
                                        //@ts-ignore
                                        temp.PtoPlanId = item.value
                                        this.manageState([{ key: "employee", value: temp }])
                                    }}
                                />
                            </div>
                            {/***************************************************************************************************/}
                            <div className="AddEmployeeFormItem">
                                <div className="AddEmployeeFormItemHeader">
                                    <p>Pay Rate</p>
                                    <div className="AddEmployeeFormItemStatus">
                                        {formStatus.missing.includes("PayRate") && <span className="material-icons AddEmployeeFormItemStatusMarkerRed">*</span>}
                                    </div>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "PayRate" }])}
                                    onChange={this.handleChange}
                                    value={employee.PayRate || ""}
                                    type="number"
                                    min="0.01"
                                    step="0.01"
                                />
                            </div>
                            {/***************************************************************************************************/}
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="AddEmployeeModalFooter">
                            {!state.loading && <div className="AddEmployeeModalFooterControls">
                                <Button variant="secondary" onClick={() => props.manageParentState([{ key: "addEmployee" }])}>Quit</Button>
                                {canSubmit && <Button onClick={() => this.addEmployee()}>Save</Button>}
                                {!canSubmit && <div className="AddEmployeeModalFooterControlsCantSave">
                                    <OverlayTrigger delay={{ show: 0, hide: 400 }} placement="top" overlay={missingFieldsdpopover}>
                                        <span className="material-icons">info</span>
                                    </OverlayTrigger>
                                    <Button id="add-employee-modal-footer-controls-cant-save-btn" disabled>Save</Button>
                                </div>}
                            </div>}
                            {state.loading && <div className="AddEmployeeModalFooterLoading">
                                <Spinner id="add-employee-load-spinner" animation="border" />
                            </div>}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    userReference: state.userReference.userReference
})

export default connect(mapStateToProps)(AddEmployee)